import React from "react";

const TMDB_SEARCH_URL = "https://www.themoviedb.org/search/person?query=";

function DirectorLink({ director }) {
  if (!director) return null;

  const names = director.split(",").map((name) => name.trim());

  return (
    <>
      {names.map((name, index) => (
        <React.Fragment key={name}>
          {index > 0 && ", "}
          {name.toLowerCase() === "various" ? (
            name
          ) : (
            <a
              href={`${TMDB_SEARCH_URL}${encodeURIComponent(name)}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit" }}
            >
              {name}
            </a>
          )}
        </React.Fragment>
      ))}
    </>
  );
}

export default DirectorLink;
